import store from "@/store";

export const ListMatch = {
  methods: {
    getListMatch(candidates) {
      let [count, sum] = Object.values(candidates).reduce(
        ([count, sum], id) => {
          let candidate = store.getters["candidate/candidate"](id);

          if (candidate.matchPercent !== undefined) {
            count += 1;
            sum += candidate.matchPercent;
          }

          return [count, sum];
        },
        [0, 0]
      );

      if (count != 0) {
        return sum / count;
      } else {
        return 0;
      }
    }
  }
};
